const HexPageTitle = ({ title, className }) => {
  return (
    <div className={`font-24-bold-500 ${className || ""}`}>{title}</div>
  );
};

export default HexPageTitle;
